<template>
  <div>
    <v-tabs id="user-management-tabs" v-model="currentTab" fixed-tabs centered hide-slider>
      <v-tab v-for="tab in tabs" :key="tab.name" :href="tab.href" :ripple="false">
        {{ tab.name }}
      </v-tab>
    </v-tabs>
    <v-divider class="ma-0" />
  </div>
</template>
<script>
  export default {
    props: {
      currentTab: {
        type: String,
        default: '',
      },
    },

    data: () => ({
      tabs: [
        {
          name: 'Library Users',
          href: 'ManageUsers',
        },
        {
          name: 'Authors',
          href: 'ManageAuthors',
        },
        {
          name: 'Peer Reviewers',
          href: 'ManagePeerReviewers',
            },
         {
          name: 'Registrant Access',
          href: 'ManageRegistrantAccess',
        },
        {
          name: 'Admins',
          href: 'ManageAdmins',
        }],
    }),
  };
  </script>
  <style>
  #user-management-tabs .v-tabs__item.v-tabs__item--active{
    color: #D2202F;
    font-weight: bold;
  }
  </style>